import React from "react";
import { Link } from "react-router-dom";

function SignoutBlueButton({ text, icon: Icon }) {
  const handleSignOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("lender_id");
    localStorage.removeItem("lender_type");
    localStorage.removeItem("lender_uuid");
  };
  return (
    <>
      <Link to="/signout" onClick={handleSignOut}>
        <button className="w-[100px] mt-4 flex items-center justify-center   rounded-[5px] bg-[#00394d] text-white hover:bg-[#a0ff77] hover:text-[#00394d] h-[40px] cursor-pointer ">
          <span className="hidden lg:flex lg:items-center text-xl">
            {Icon && <Icon className="w-[25px] h-[25px] " />}
            <span
              className="text-[14px] font-semibold leading-6 capitalize ml-2 "
              aria-hidden="true"
            >
              {text}
            </span>
          </span>
        </button>
      </Link>
    </>
  );
}

export default SignoutBlueButton;
